// A short fingerprint of the constraint catalogue (FNV-1a, 32 bits), stored with each rule
// reading: a reading made against an older catalogue may have missed types added since, so the
// retry of needs-a-plugin puzzles reads it again (2026-11-01).
import { CONSTRAINT_CATALOGUE } from './catalogue';

export function fingerprint(text: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h.toString(16).padStart(8, '0');
}

export const CATALOGUE_VERSION = fingerprint(CONSTRAINT_CATALOGUE);
